import { render, staticRenderFns } from "./title-bar.vue?vue&type=template&id=35328341&"
import script from "./title-bar.vue?vue&type=script&lang=js&"
export * from "./title-bar.vue?vue&type=script&lang=js&"
import style0 from "./title-bar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports